import { render, staticRenderFns } from "./company-manage.vue?vue&type=template&id=2e053292&"
import script from "./company-manage.vue?vue&type=script&lang=js&"
export * from "./company-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports